/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@pwc/pwc-deals-ui';
import { getIsDarkModeSelector } from 'common/redux/userSettings/userSettingsSlice';
import RibbonPanelIcon from '../RibbonPanel/RibbonPanelIcon';

export type RibbonButtonBadge = {
  text: string;
  className?: string;
};

export type RibbonButtonTypes = 'comment' | 'preview' | 'versioning';

export type RibbonButtonTypeProps = {
  type: RibbonButtonTypes | null;
  badge?: RibbonButtonBadge;
};

type Props = {
  ribbon: RibbonButtonTypeProps;
  ribbonType: string | null;
};

const RibbonPanelButton: FC<Props> = ({ ribbon, ribbonType }) => {
  const darkMode = useSelector(getIsDarkModeSelector);
  const { t } = useTranslation();
  const tooltipName = useMemo(() => {
    if (ribbon.type === 'comment') {
      return t('comments');
    }
    if (ribbon.type === 'versioning') {
      return t('versioning');
    }
    return t('reportPreview');
  }, [ribbon, t]);

  return (
    <Tooltip
      direction="bottom"
      tip={tooltipName}
      dataTestId={undefined}
      unthemed={undefined}
      showingInitial={undefined}
    >
      <RibbonPanelIcon
        className="outline icon-grey-theme"
        name={ribbon.type}
        isDarkMode={darkMode}
        ribbonType={ribbonType}
      />
    </Tooltip>
  );
};

export default RibbonPanelButton;
